import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { settleHandoff } from '../sessionHandoff';

export const useAuth = () => {
  const [session, setSession] = useState(null);
  const [access, setAccess] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      // A session handed over from web3kurzus.hu must be in place before we
      // decide the user is signed out (ProtectedRoute would redirect to /login).
      await settleHandoff();
      const { data: { session } } = await supabase.auth.getSession();
      setSession(session);

      if (session) {
        const { data } = await supabase
          .rpc('get_user_access')
          .single();
        setAccess(data ? { ...data, is_og: data.is_og || false } : null);

        const { data: profileData } = await supabase
          .from('profiles')
          .select('full_name, total_xp, streak_days, last_activity_date, discord_user_id')
          .eq('id', session.user.id)
          .single();
        setProfile(profileData);
      }
      setLoading(false);
    };
    init();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        setSession(session);
        if (session) {
          const { data } = await supabase
            .rpc('get_user_access')
            .single();
          setAccess(data ? { ...data, is_og: data.is_og || false } : null);

          const { data: profileData } = await supabase
            .from('profiles')
            .select('full_name, total_xp, streak_days, last_activity_date, discord_user_id')
            .eq('id', session.user.id)
            .single();
          setProfile(profileData);
        } else {
          setAccess(null);
          setProfile(null);
        }
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  // A gombos próba után (TrialStrip) a hozzáférést újra kell olvasni.
  const refreshAccess = async () => {
    const { data } = await supabase.rpc('get_user_access').single();
    if (data) setAccess({ ...data, is_og: data.is_og || false });
  };

  return { session, access, loading, profile, refreshAccess };
};
